import "../../../../../../../node_modules/bxslider/dist/jquery.bxslider.js";
import {PewComponent} from "../../../assets/raw/js/components/pew-component";

// see https://bxslider.com/options/
const SliderOptions = {
    mode: 'horizontal',
    autoControlsCombine: true,
    keyboardEnabled: true,
    easing: 'ease-in-out',
    speed: 700,
    pause: 2000,
    auto: true,
    autoControls: false,
    pager: true,
    minSlides: 1,
    maxSlides: 7,
    moveSlides: 1,
    slideWidth: 160,
    slideMargin: 20,
    shrinkItems: true,
    stopAutoOnClick: true,
    touchEnabled: (window.innerWidth<1025)
};

export class SliderPartnerComponent extends PewComponent {
    constructor(element) {
        let opts = SliderOptions;
        let isMobile = (window.innerWidth<768);

        if(isMobile) {
            opts['minSlides'] = 1;
            opts['maxSlides'] = 1;
            opts['slideWidth'] = 0;
        }

        super(element, opts);
    }
    init() {
        jQuery(window).on("load", ()=> {
            this.element.bxSlider(this.options);
            setTimeout(()=>{
                this.element.redrawSlider();
            },500);
        });
    }
}

window.pew.addRegistryEntry({key: 'wdf-slider-partner', domSelector: '.wdf-slider-partenaires', classDef: SliderPartnerComponent});



// WEBPACK FOOTER //
// ./web/app/themes/wwp_child_theme/includes/Components/Slider/SliderPartnerComponent.js